<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="paymentmethods.icon" class="mr-1"></i>
                        <span>{{ paymentmethods.title }}</span>
                    </b-col>
                </b-row>

            </b-card-header>

            <div v-if="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">

                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="code" :debounce="paymentmethods.debounce"
                                            placeholder="Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!code"
                                                @click="code = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="paymentmethods.debounce"
                                            placeholder="Description"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="paymentmethods" :icon="paymentmethods.icon"
                        :busy="paymentmethods.busy" :toolbarlibrary="paymentmethods.toolbarlibrary"
                        :tools="paymentmethods.tools" :badges="paymentmethods.badges"
                        :fields="paymentmethods.fields" :items="paymentmethods.items"
                        :limit="paymentmethods.limit" :downloaded="paymentmethods.downloaded"
                        :page="paymentmethods.page" @load="paymentmethods_load" @click="paymentmethods_click"
                        @changed="paymentmethods_click('save', $event)" @select="paymentmethods_select">
                    </d-table>
                </div>
            </div>

            <div v-if="component">
                <component :is="component" :selection="paymentmethods.selected" :config="cconfig"
                    @discard="paymentmethods_click('discard')" @go="paymentmethods_click('go')"></component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-bars mr-2"></i>All Codes
                    </b-button>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import Setup_ClientAccountTypesEdit from "./Components/Setup_ClientAccountTypesEditN";

export default {
    name: "ClientAccountTypesN",
    components: { Setup_ClientAccountTypesEdit },
    watch: {
        async code() {
            await this.paymentmethods_load(0);
        },
        async description() {
            await this.paymentmethods_load(0);
        }
    },
    data() {
        return {
            code: null,
            description: null,

            paymentmethods: {
                title: "Client Account Types SQL",
                icon: "fa fa-bars",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,


                tools: "go,filter,download,add,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-35px",
                    },

                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                    },

                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                    },

                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.paymentmethods_load();
    },
    methods: {
        accessdenied() {
            this.paymentmethods.denied = [];
            if (!this.user.permissions.includes("setup_paymentmethods.admin")) {
                this.paymentmethods.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_paymentmethods.admin")) {
                this.paymentmethods.denied.push("add");
                this.paymentmethods.denied.push("save");
            }

        },
        async paymentmethods_load(offset, limit, page) {
            console.log('paymentmethods_load', offset, limit, page)
            let state = this.paymentmethods;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                code: this.code,
                description: this.description
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_paymentmethods(
                $limit: Int
                $offset: Int
                   $code: String     
                $description: String                 
              ) {
                setup_paymentmethods(
                  limit: $limit
                  offset: $offset
                  description: $description 
                  code: $code                  
                ) {
                id
                code
                description              
                rows
                updated_at
                updated_by
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE  

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_paymentmethods
                } else {
                    state.items = response.data.setup_paymentmethods;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async paymentmethods_click(a, ss) {

            let state = this.paymentmethods;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.paymentmethods_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    break;
                case "go":
                    this.component = null;
                    this.paymentmethods_load();
                    break;
                case "add":
                case "edit":
                    this.component = "Setup_ClientAccountTypesEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async paymentmethods_select(ss, tools) {

            let state = this.paymentmethods;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {

            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_paymentmethods_save(
                $rows: [setup_paymentmethods_input]             
              ) {
                setup_paymentmethods_save(rows: $rows) {
                    id
                    description              
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_paymentmethods_delete(
                $rows: [setup_paymentmethods_input]
              ) {
                setup_paymentmethods_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.paymentmethods_load(0);
        },
    },
};
</script>

<style></style>